<template>
  <div>
    <b-row style="margin-top: 2em">
      <b-col>
        <b-card bg-variant="light">
          <b-row>
            <b-col>
              <h5 class="text-info">
                {{ $t("globals.synatec_orders") }}:
              </h5>
            </b-col>
          </b-row>
          <!-- Search Row -->
          <b-row>
            <b-col class="my-3">
              <b-input-group>
                <b-form-input
                  v-model="filter"
                  :placeholder="$t('globals.type_to_search')"
                />
                <b-input-group-append>
                  <b-btn
                    variant="warning"
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    {{ $t("globals.clear") }}
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col cols="2" class="my-3">
              <b-form-select v-model="perPage" :options="perPageOptions" />
            </b-col>
          </b-row>
          <!-- Table -->
          <b-row>
            <b-col>
              <b-table
                :items="synatec_orders"
                :fields="fields"
                :filter="filter"
                :current-page="currentPage"
                @filtered="currentPage = 1"
                :sortable = false
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                
                bordered
                small
                hover
                sort-icon-left
                
                
                
                
                @row-clicked="goToSynatecOrder"
              >
                <template v-slot:cell(order)="row">
                  <router-link
                    style="color:#17a2b8"
                    :to="{ name: 'order', params: { id: row.item.id } }"
                    target="_blank"
                  >
                    {{ row.item.order.order_no }}
                  </router-link>
                </template>
                <!-- Status -->
                <template v-slot:cell(status)="row">
                  <b-badge :variant="row.item._rowVariant">
                    {{ $t("globals." + row.item.status) }}
                  </b-badge>
                </template>
                <!-- Created at -->
                <template v-slot:cell(created_at)="row">
                  <div v-b-tooltip.hover :title="row.item.created_at">
                    {{ row.item.created_at.substring(0, 10) }}
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <!-- Pagination -->
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                :total-rows="total"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  props: {
    customer:{
      type: Number,
      require: true
    },
  },
  data() {
    return {
      total:0,
      synatec_orders: () => ({}),
      filter: null,
      sortBy: "created_at",
      currentPage: 1,
      sortDesc: true,
      perPage: 10,
      perPageOptions: [
        { text: "10 " + this.$t("globals.per_page"), value: 10 },
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "30 " + this.$t("globals.per_page"), value: 30 }
      ],
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true
        },
        {
          key: "order",
          label: this.$t("globals.order"),
          sortable: true
        },
        {
          key: "agent.full_name",
          label: "agent",
          sortable: true
        },
        {
          key: "status",
          label: this.$t("globals.status"),
          sortable: true
        },
        {
          key: "created_at",
          label: this.$t("globals.created_at"),
          sortable: true
        }
      ]
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation", "simpleFetch"]),
    ...mapMutations(["setShowLoadingModal"]),
    fetchTotalSynatec(){
      const data = {
        query: `query { Customer(id:${parseInt(this.customer)}){ synatec_orders_total }}`
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.total = res.Customer.synatec_orders_total;
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
      });
    },
    fetchSynatec() {
      const offset = (this.currentPage-1) * this.perPage;
      const sort = this.sortDesc ? 'desc' : 'asc'
      const data = {
        query: `
        query {
          Customer(id:${parseInt(this.customer)}){  
            synatecPagination (
              sortBy:"${this.sortBy}", 
              sort:"${sort}"
              limit: ${parseInt(this.perPage)},
              offset: ${parseInt(offset)}

            ){ 
            
                  id
                  agent {
                      full_name
                  }
                  order {
                      id
                      order_no
                  }
                  status
                  created_at
                  _rowVariant
              
            }
          }
        }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.synatec_orders = res.Customer.synatecPagination;
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
        });
    },
    goToSynatecOrder(item) {
      this.$router.push({
        name: "synatecorder",
        params: { id: item.id }
      });
    }
  },
  mounted() {
    this.fetchTotalSynatec();
  },
  watch:{
    total(n,o){
      if(this.total){
        this.fetchSynatec();
      }
    },
    currentPage(n,o){
      this.fetchSynatec();
    },
    perPage(n,o){
      this.fetchSynatec();
    },
    sortBy(n,o){
      this.fetchSynatec();
      // this.currentPage = 1; // To stay in the current page keep this commented, if after a sort it needs to go to the first page, uncomment
    },
    sortDesc(n,o){
      this.fetchSynatec();
      // this.currentPage = 1; // To stay in the current page keep this commented, if after a sort it needs to go to the first page, uncomment
    }
  }
};
</script>
